import { Routes } from '@angular/router';
import { AuthGuard } from 'app/authentication/guard/auth.guard';

import { VideoConferencePage } from './components/vc-page/vc-page.component';

export const VideoConferenceRoutes: Routes = [
	{
		path: 'session/:appointmentId',
		component: VideoConferencePage,
		canActivate: [AuthGuard],
	},
];
